export const REGULAR_SYNC_WEIGHT = 2;
export const PAGINATED_SYNC_WEIGHT = 5;
export const ITEMS_SYNC_WEIGHT = 90;

export interface StageProgress {
    staff?: number;
    items?: number;
    pricingGroups?: number;
    categories?: number;
    measurementUnits?: number;
    discounts?: number;
    paymentMethods?: number;
    taxes?: number;
    subscription?: number;
    terminals?: number;
    modifiers?: number;
}

export const SYNC_WEIGHTS: Required<StageProgress> = {
    items: ITEMS_SYNC_WEIGHT,

    pricingGroups: PAGINATED_SYNC_WEIGHT,
    categories: PAGINATED_SYNC_WEIGHT,
    measurementUnits: PAGINATED_SYNC_WEIGHT,
    discounts: PAGINATED_SYNC_WEIGHT,

    staff: REGULAR_SYNC_WEIGHT,
    paymentMethods: REGULAR_SYNC_WEIGHT,
    taxes: REGULAR_SYNC_WEIGHT,
    subscription: REGULAR_SYNC_WEIGHT,
    terminals: REGULAR_SYNC_WEIGHT,
    modifiers: PAGINATED_SYNC_WEIGHT,
};

export const CUMMULATIVE_WEIGHTS = Object.values(SYNC_WEIGHTS).reduce(
    (acc, weight) => acc + weight,
    0,
);
